import React from 'react';
import { CHECKOUT_URL } from '../data/content';
interface CTAButtonProps {
  label: string;
  sub?: string;
  variant?: 'primary' | 'dark';
  className?: string;
}
export function CTAButton({
  label,
  sub,
  variant = 'primary',
  className = ''
}: CTAButtonProps) {
  const base = variant === 'primary' ? 'bg-forest-mid hover:bg-forest text-white ring-forest-mid/25' : 'bg-navy hover:bg-navy-deep text-white ring-navy/25';
  return <div className={`w-full ${className}`} data-id="element-25" data-mp="2txjm4cgchv9q">
      <a href={CHECKOUT_URL} className={`group flex w-full items-center justify-center gap-2 rounded-2xl px-5 py-4 text-center text-[15px] font-extrabold uppercase leading-tight tracking-wide ring-4 transition-[transform,background-color,box-shadow] duration-150 ease-out hover:-translate-y-0.5 active:translate-y-0 sm:text-lg ${base}`} data-id="element-26" data-mp="2p0ji073232l9">
        <span className="text-balance" data-id="element-27" data-mp="3cnrjedxd5ri0">{label}</span>
      </a>
      {sub ? <p className="mt-3 text-center text-[13px] font-medium text-ink/60 sm:text-sm" data-id="element-28" data-mp="38ptulc7i97f5">{sub}</p> : null}
    </div>;
}